"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalysisType = void 0;
var AnalysisType;
(function (AnalysisType) {
    AnalysisType["Apk"] = "Apk";
    AnalysisType["Apt"] = "Apt";
    AnalysisType["Rpm"] = "Rpm";
    AnalysisType["Binaries"] = "binaries";
    AnalysisType["Linux"] = "linux";
})(AnalysisType = exports.AnalysisType || (exports.AnalysisType = {}));
//# sourceMappingURL=types.js.map